import urlToImage from '../urlToImage';

export default async function imageDimensions(url: string) {
  const img = await urlToImage(url);
  return { width: img.width, height: img.height };
}
